import React from 'react';
import { useSelector } from 'react-redux';

import PuppiesList from './PuppiesList';
import UpcomingLittersList from './UpcomingLittersList';
import ReservedAndPastPuppiesList from './ReservedAndPastPuppiesList';
import AdultDogsList from './AdultDogsList';
import WorkingWithBreederSection from './WorkingWithBreederSection';
import OverviewCard from './OverviewCard';
import BreederProfileReviews from '../reviews/BreederProfileReviews';

export default function BreederProfileOverviewTab() {
  const { hasCurrentLitters, hasPastPuppies, reservedPuppyCount } = useSelector(
    ({ server }) => server
  );

  return (
    <div className="BreederProfileOverviewTab">
      <OverviewCard />
      {hasCurrentLitters && (
        <>
          <PuppiesList />
          <AdultDogsList />
          <UpcomingLittersList />
        </>
      )}
      <WorkingWithBreederSection />
      {(hasPastPuppies || reservedPuppyCount > 0) && (
        <ReservedAndPastPuppiesList />
      )}
      <BreederProfileReviews className="pv8" navigateToTab reviewsPerPage={3} />
    </div>
  );
}
